export const LOG_TIPLERI = [
  { value: 'error',      label: '🔴 Hatalar'    },
  { value: 'request',    label: '📥 İstekler'   },
  { value: 'validation', label: '✅ Validasyon' },
  { value: 'process',    label: '⚙️ İşlemler'  },
];

export const MODULLER = [
  { value: '',               label: 'Tüm Modüller'      },
  { value: 'UserAPI',        label: 'UserAPI'            },
  { value: 'SurveyAPI',      label: 'SurveyAPI'          },
  { value: 'ExportAPI',      label: 'ExportAPI'          },
  { value: 'ImportAPI',      label: 'ImportAPI'          },
  { value: 'IntegrationAPI', label: 'IntegrationAPI'    },
  { value: 'ScheduledJobsAPI', label: 'ScheduledJobsAPI' },
  { value: 'CustomAPI', label: 'CustomAPI' },
];

export const HATA_TIPLERI = [
  { value: '',              label: 'Tüm Hata Tipleri' },
  { value: 'Anlik Hata',   label: '🔴 Anlık Hata'    },
  { value: 'Tekrarli Hata',label: '🟡 Tekrarlı Hata' },
];

export const VALIDATION_SONUCLARI = [
  { value: '',       label: 'Tüm Sonuçlar' },
  { value: 'Passed', label: '✅ Passed'     },
  { value: 'Failed', label: '❌ Failed'     },
];

export const PROCESS_DURUMLARI = [
  { value: '',            label: 'Tüm Durumlar'  },
  { value: 'Tamamlandi',  label: '✅ Tamamlandı' },
  { value: 'Baslatildi',  label: '▶️ Başlatıldı' },
  { value: 'DevamEdiyor', label: '🔄 Devam'      },
  { value: 'Atland',      label: '⏭️ Atlandı'   },
];

export const ZAMAN_ARALIK = [
  { value: 1,        label: 'Son 1 saat'  },
  { value: 6,        label: 'Son 6 saat'  },
  { value: 'bugun',  label: 'Bugün'       },
  { value: 'dun',    label: 'Dün'         },
  { value: 168,      label: 'Son 7 gün'   },
  { value: 720,      label: 'Son 30 gün'  },
  { value: 'custom', label: 'Özel...'     },
];

export const SIRALA_SECENEKLERI = {
  error:      [
    { value: 'sayi_desc',  label: 'Tekrar Sayısı ↓' },
    { value: 'zaman_desc', label: 'Son Görülme ↓'   },
  ],
  request:    [
    { value: 'zaman_desc', label: 'En Yeni ↓' },
    { value: 'zaman_asc',  label: 'En Eski ↑' },
  ],
  validation: [
    { value: 'zaman_desc',   label: 'En Yeni ↓'    },
    { value: 'failed_first', label: 'Hatalı Önce'  },
  ],
  process:    [
    { value: 'zaman_desc', label: 'En Yeni ↓'  },
    { value: 'sure_desc',  label: 'En Yavaş ↓' },
    { value: 'sure_asc',   label: 'En Hızlı ↑' },
  ],
};

const MUSTERI_LISTESI = [
    { value: '0', label: 'Cloud4Feed' },
    { value: '1', label: 'Acsight Tenant (TR)' },
    { value: '2', label: 'Acsight Tenant (EN)' },
    { value: '3', label: 'BTA Food and Services' },
    { value: '4', label: 'CK Enerji Dağıtım' },
    { value: '5', label: 'Penti Giyim Ticaret Anonim Şirketi' },
    { value: '6', label: 'Teknosa İç ve Dış Ticaret A.Ş' },
    { value: '7', label: 'CK Enerji Perakende' },
    { value: '8', label: 'Vakıf Katılım' },
    { value: '9', label: 'Anadolu Sigorta' },
    { value: '10', label: 'Yargıcı' },
    { value: '11', label: 'Gratis' },
    { value: '12', label: 'Adventica' },
    { value: '13', label: 'Sigortaladim.com' },
    { value: '14', label: 'Vaillant' },
    { value: '15', label: 'AFS Research' },
    { value: '16', label: 'Medicana' },
    { value: '17', label: 'YDA Dalaman' },
    { value: '18', label: 'Fabay İnşaat' },
    { value: '19', label: 'Koçtaş' },
    { value: '20', label: 'Zorlu Holding' },
    { value: '21', label: 'Agesa' },
    { value: '22', label: 'Webbilir' },
    { value: '23', label: 'C4F' },
    { value: '24', label: 'Yedas' },
    { value: '25', label: 'Constructor' },
    { value: '26', label: 'Vakko' },
    { value: '27', label: 'Tuğba Giyim' },
    { value: '28', label: 'Tredaş' },
    { value: '29', label: 'Zoho Demo Tenant' },
    { value: '30', label: 'Yves' },
    { value: '31', label: 'Eedas' },
    { value: '32', label: 'Bilgi' },
    { value: '33', label: 'E-Bebek' },
    { value: '34', label: 'Flo' },
    { value: '35', label: 'Sigortam' },
    { value: '36', label: 'Benetton' },
    { value: '37', label: 'Mad' },
    { value: '38', label: 'Çevre Hastanesi' },
    { value: '39', label: 'Beymen Giyim' },
    { value: '40', label: 'A101' },
    { value: '41', label: 'Defacto' },
    { value: '42', label: 'Adesso' },
    { value: '43', label: 'Ipekyol' },
    { value: '44', label: 'Fiba Retail' },
    { value: '45', label: 'TIKLA GELSIN' },
    { value: '46', label: 'Limak Çimento' },
    { value: '47', label: 'Hayat Kimya' },
    { value: '48', label: 'LCW' },
    { value: '49', label: 'Paribu Cineverse' },
    { value: '50', label: 'Derindere Filo' },
    { value: '51', label: 'İTK Mezunları' },
    { value: '52', label: 'Nihan Giyim' },
    { value: '53', label: 'Hemington' },
    { value: '54', label: 'Sardunya' },
    { value: '55', label: 'Dev Team' },
    { value: '56', label: 'Aymarka' },
    { value: '57', label: 'BTA - Cakes&Bakes FABRIKA' },
    { value: '58', label: 'Research Acsight' },
    { value: '59', label: 'YDA Dalaman' },
    { value: '60', label: 'TAV' },
    { value: '61', label: 'Rahbar Bazaar' },
    { value: '62', label: 'Brisa' },
    { value: '63', label: 'CX' },
    { value: '64', label: 'Supplementler' },
    { value: '65', label: 'BeeFull' },
    { value: '66', label: 'Iveco' },
    { value: '67', label: 'Concentrix' },
    { value: '68', label: 'Asuman' },
    { value: '69', label: 'English Home' },
    { value: '70', label: 'DRD Filo' },
    { value: '71', label: 'BTA - TAV Airport Hotel ' },
    { value: '72', label: 'Mudo Tekstil' },
    { value: '73', label: 'Barikat Siber Güvenlik' },
    { value: '74', label: 'BÜMED' },
    { value: '75', label: 'test' },
    { value: '76', label: 'Skechers' },
    { value: '77', label: 'Millenicom' },
    { value: '78', label: 'Flogroup' },
    { value: '79', label: 'Fenerium' },
    { value: '80', label: 'Çetinkaya' },
    { value: '81', label: 'KUTEZ' },
    { value: '82', label: 'Dagi' },
    { value: '83', label: 'Defacto NLP' },
    { value: '84', label: 'Defacto' },
    { value: '85', label: 'SemaAktürk' },
    { value: '86', label: 'Cengiz Yorgancıoğlu' },
    { value: '87', label: 'Seçil Göktaş' },
    { value: '88', label: 'Total' },
    { value: '89', label: 'Fuzulev' },
    { value: '90', label: 'Gülçin Çelikbıçak' },
    { value: '91', label: 'İnoksan' },
    { value: '92', label: 'Serenay Akciyer' },
    { value: '93', label: 'Serenay Akciyer' },
    { value: '94', label: 'Doğanlar Mobilya' },
    { value: '95', label: 'Serhan Devran' },
    { value: '96', label: 'Ayça Bülbül' },
    { value: '97', label: 'Asis Elektronik' },
    { value: '98', label: 'Doğtaş Mobilya' },
    { value: '99', label: 'Özak Global' },
    { value: '100', label: 'Altınay' },
    { value: '101', label: 'Gürgençler' },
    { value: '102', label: 'Avon' },
    { value: '103', label: 'Eren Perakende' },
    { value: '104', label: 'Jason Bradshaw' },
    { value: '105', label: 'Ipekyol' },
    { value: '106', label: 'Gree' },
    { value: '107', label: 'Ford Trucks' },
    { value: '108', label: 'ApiCenter' },
    { value: '109', label: 'Rossmann' },
    { value: '110', label: 'Asics' },
    { value: '111', label: 'Jolly Tur' },
    { value: '112', label: 'Akin Onboarding' },
    { value: '116', label: 'Berat Onboarding  ' },
    { value: '117', label: 'Tchibo' },
    { value: '118', label: 'Türk Telekom' },
    { value: '119', label: 'Code Event' },
    { value: '120', label: 'Mehmet Test Client' },
    { value: '121', label: 'CX Touchpoints' },
    { value: '122', label: 'Beymen' },
    { value: '127', label: 'Techstalwarts' },
    { value: '128', label: 'QNB' },
    { value: '129', label: 'Fakir' },
    { value: '130', label: 'Derimod' },
    { value: '136', label: 'invent' },
    { value: '140', label: 'CK Enerji HR - EX' },
    { value: '141', label: 'SPX' },
    { value: '142', label: 'fredericpatric' },
    { value: '143', label: 'Aktif Bank' },
    { value: '144', label: 'Carrefoursa' },
    { value: '145', label: 'Greyder' },
    { value: '146', label: 'Spor İstanbul' },
    { value: '147', label: 'AssisTT' },
    { value: '148', label: 'İETT' },
    { value: '149', label: 'Tech İstanbul' },
    { value: '150', label: 'Colorsofmarketing' },
    { value: '151', label: 'DR' },
    { value: '152', label: 'SPX EX' },
    { value: '153', label: 'Escorts Kubota' },
    { value: '154', label: 'communite' },
    { value: '155', label: 'Vestel' },
    { value: '156', label: 'Gurmen' }
];

export const MUSTERILER = [...MUSTERI_LISTESI].sort((a, b) =>
  a.label.localeCompare(b.label, 'tr')
);

/**
 * Gösterilmeyecek endpoint listesi.
 * Bu listedeki endpoint'lere ait istekler client tarafında filtrelenir.
 */
export const GIZLI_ENDPOINTLER = [
  '/api/notification/latest',
];
